export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('click-outside', {
    beforeMount(el, binding) {
      el.clickOutsideEvent = function (event) {
        if (binding.value) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event, el);
          }
        }
      };

      if (typeof document !== 'undefined') {
        document.body.addEventListener('click', el.clickOutsideEvent);
      }
    },
    unmounted(el) {
      if (typeof document !== 'undefined') {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      }
    },
  })
});
